export const getQueryParam = (key: string): string | null =>
  typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get(key) : null;

/** Payload's login view decodes `?redirect=` once more after Next has, so a query inside it must be encoded twice to survive. */
export const loginRedirectParam = (path: string): string => encodeURIComponent(encodeURIComponent(path));

/** `new URL` throws on unparseable input. */
export const parseUrl = (value: string, base?: string): URL | undefined => {
  try {
    return new URL(value, base);
  } catch {
    return;
  }
};

export const stripTrailingSlash = (value: string): string => value.replace(/\/+$/, '');

const LOOPBACK_HOSTS: ReadonlySet<string> = new Set(['localhost', '127.0.0.1', '[::1]']);

export const isLoopbackUrl = (url: URL): boolean => LOOPBACK_HOSTS.has(url.hostname);

/** The two schemes a link this server hands out, or follows, may use. */
export const isHttpUrl = (url: URL): boolean => url.protocol === 'http:' || url.protocol === 'https:';
